import { Form, Input, ModalProps, FormProps, Modal, InputNumber, useSelect, Select } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { ICompetency, IStrand, ITeacherLevel, ITNTaxonomy } from 'interfaces'
import React, { useState } from 'react'

type CreateStrandProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const CreateStrand: React.FC<CreateStrandProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()
  const [taxonomyfilter, setTaxonomyFilter] = useState([])

  const { selectProps: teacherlevelSelectProps } = useSelect<ITeacherLevel>({
    resource: 'teacher_levels',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const { selectProps: tntaxonomySelectProps } = useSelect<ITNTaxonomy>({
    resource: 'tn_taxonomys',
    fetchSize: 1000,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      ...(taxonomyfilter ?? []),
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const handleTaxonomyChange = (value: { value: any }) => {
    let data: any = [
      {
        field: 'competency_id',
        operator: 'eq',
        value: value,
      },
    ]
    setTaxonomyFilter(data)
  }

  const { selectProps: CompetenciesSelectProps } = useSelect<ICompetency>({
    resource: 'competencies',
    fetchSize: 1000,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => {
      return [
        {
          field: 'name',
          operator: 'contains',
          value: `${value.toLowerCase()}%`,
        },
      ]
    },
  })
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {
    return (
      formProps.onFinish &&
      formProps.onFinish({
        ...values,
        created_by: user?.id,
      })
    )
  }

  return (
    <Modal {...modalProps} title="Create Standard">
      <Form
        {...formProps}
        size="large"
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            if (response) {
              createUserHistory('strands', 'create', response?.data?.id, user?.id, userRole)
            }
          })

          return response
        }}
      >
        <Form.Item
          label="Standard"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Competenices"
          name="competency_id"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select onChange={handleTaxonomyChange} {...CompetenciesSelectProps} />
        </Form.Item>
        <Form.Item
          label="Taxonomy"
          name="taxonomy_id"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select {...tntaxonomySelectProps} />
        </Form.Item>
        <Form.Item
          label="Teacher level"
          name="teacher_level_id"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select {...teacherlevelSelectProps} />
        </Form.Item>
        <Form.Item
          label="Description"
          name="description"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
